//location and search are props that live in all top level components in the app. So you would call (getQueryParams(this.props.location))

export function getQueryParams(location) {
  const { search } = location;

  const query = {};
  let pairs = (search[0] === '?' ? search.substr(1) : search).split('&');

  for (let i = 0; i < pairs.length; i++) {
    let pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }

  return query;
}

export function addOrUpdateParams(data, history) {
  let keys = Object.keys(data);
  let params = this.getQueryParams();
  let nextParams = [];

  keys.forEach((key) => {
    if (params[key]) {
      params[key] = data[key];
    } else {
      params[key] = data[key];
    }
  });

  for (let param in params) {
    if (param !== '') {
      nextParams.push(`${param}=${params[param]}`);
    }
  }

  nextParams = nextParams.join('&');

  history.push({
    search: `?${nextParams}`,
  });
}

export function removeParams(paramsToDelete = [], history) {
  let params = this.getQueryParams();
  let nextParams = [];

  paramsToDelete.forEach((param) => {
    if (params[param]) {
      delete params[param];
    }
  });

  for (let param in params) {
    if (param !== '') {
      nextParams.push(`${param}=${params[param]}`);
    }
  }

  if (nextParams.length > 0) {
    nextParams = nextParams.join('&');
    history.push({
      search: `?${nextParams}`,
    });
  } else {
    history.push({
      search: '',
    });
  }
}
